import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'ps',
    fullName: 'Pashto',
    nativeName: 'پښتو',
    direction: 'rtl'
};

const translations: LocaleData = {
    title: "ارګ وایډ",
    landing_title: "یو څه حیرانتیا راځي",
    landing_subtitle: "ArgVoid یو اپلیکیشن او د لوبې پراختیا سټوډیو ده. سره پاتې شئ، نوي شیان ژر راځي!",
    select_language: "ژبه غوره کړئ",
    search_placeholder: "ژبې لټون...",
    terms_title: "د خدمت شرطونه",
    policy_title: "د محرمیت پالیسي",
    cookies_title: "د کوکي پالیسي",
    terms_content: `
        <strong>1. د شرطونو منل </strong><br>
        ArgVoid ته د لاسرسي له لارې، د خدماتو دا شرایط منل کیږي. که دا شرایط ونه منل شي، خدمت باید ونه کارول شي.<br><br>

        <strong>2. د پلیټ فارم کارول</strong><br>
        ArgVoid او د هغې غوښتنلیکونه د معلوماتي او تخلیقي موخو لپاره "لکه څنګه چې دي" چمتو شوي. خدمت باید یوازې د قانوني موخو لپاره وکارول شي.<br><br>

        <strong>3. منع شوي چلند</strong><br>
        د سایټ د زیانونو څخه ګټه پورته کول، سپیم کول، یا زیربنا ته د غیر مجاز لاسرسي هڅه کول په کلکه منع دي.<br><br>

        <strong>4. اعلان </strong><br>
        پلیټ فارم او خدمات ممکن هر وخت پرته له خبرتیا بدل شي. د خدماتو د وخت یا شتون په اړه هیڅ تضمین ندی ورکړل شوی.
    `,
    policy_content: `
        <strong>1. د معلوماتو راټولول</strong><br>
        پلیټ فارم پدې وخت کې د کارونکي تصدیق یا حساب جوړولو ته اړتیا نلري. هیڅ شخصي پیژندل شوي معلومات (لکه نومونه یا بریښنالیک پتې) په فعاله توګه د لیدونکو څخه راټول شوي ندي.<br><br>

        <strong>2. Data</strong><br> کارول
        د سایټ ټرافيکي پوهیدو او غوښتنلیکونو ته وده ورکولو لپاره لومړني ، نامعلوم تحلیلونه راټول کیدی شي. دا ډاټا د انفرادي کارونکي پیژندنې سره تړاو نلري.<br><br>

        <strong>3. د دریمې ډلې خدمتونه</strong><br>
        د دریمې ډلې چمتو کونکي ممکن د کوربه توب او تحلیلي خدماتو لپاره وکارول شي. د دې اړوندو چمتو کونکو د محرمیت کړنې د دوی په زیربنا کې پروسس شوي نامعلوم ډیټا اداره کوي.<br><br>

        <strong>4. د معلوماتو امنیت</strong><br>
        د پلیټ فارم ساتلو لپاره مناسب امنیتي تدابیر پلي کیږي. په هرصورت، په انټرنیټ کې د لیږد هیڅ طریقه په بشپړه توګه خوندي نه ده.<br><br>
    `,
    cookies_content: `
        <strong>1. کوکیز او ځایی ذخیره څه شی دی؟</strong><br>
        کوکیز او د براوزر محلي ذخیره د ډیټا کوچني فایلونه دي چې په وسیله کې زیرمه شوي ترڅو د لیدنو په اوږدو کې د ترتیب غوره توبونه یاد کړي.<br><br>

        <strong>2. د کارولو هدف</strong><br>
        د براوزر LocalStorage د ترتیب ترتیباتو خوندي کولو لپاره په کلکه کارول کیږي، لکه: <br>
        - د ژبې غوره توبونه<br>
        - د کارن انٹرفیس ترتیب (د مثال په توګه، ترتیب یا د موضوع ترتیبات) <br>
        - لنډمهاله غوښتنلیک cache<br><br>

        <strong>3. نه Tracking</strong><br>
        کوکیز او ځایی ذخیره د اعلاناتو یا دریمې ډلې تعقیب موخو لپاره نه کارول کیږي. ټول ذخیره شوي ډاټا په کلکه د پلیټ فارم اصلي فعالیت لپاره دي.<br><br>

        <strong>4. Control</strong><br>
        د براوزر ډیټا هر وخت د براوزر تنظیماتو له لارې پاک کیدی شي ، کوم چې به کوم ځایي تشکیلات له سره تنظیم کړي.
    `,
    cookie_consent_text: "موږ بنسټیز کوکیز کاروو ترڅو ډاډ ترلاسه کړو چې ویب پاڼه په سمه توګه کار کوي، لکه ستاسو د ناستې فعال ساتل، ستاسو د ژبې غوره توب خوندي کول، او نور دودیز تشکیلات.",
    read_policy: "د کوکي پالیسي ولولئ",
    support_title: "د ملاتړ سره اړیکه ونیسئ",
    support_subject_label: "موضوع",
    support_message_label: "پیغام",
    support_submit_button: "پیغام واستوئ",
    support_hint: "یادونه: دا به د پیغام لیږلو لپاره ستاسو د ډیفالټ بریښنالیک غوښتنلیک خلاص کړي.",
    support_success_msg: "ستاسو د بریښنالیک اپلیکیشن خلاصول ...",
    support_error_msg: "د پیغام لیږلو کې پاتې راغلی. مهرباني وکړئ وروسته بیا هڅه وکړئ.",
    explorer_title: "سپړونکی",
    history_title: "تاریخ",
    animation_title: "حرکت",
    config_title: "ترتیب",
    tool_mouse: "وټاکئ (Ctrl+M)",
    tool_brush: "برش (Ctrl+B)",
    tool_brush_mode: "د توګل حالت (سالډ/پاک)",
    tool_eraser: "پاکونکی (Ctrl+E)",
    tool_brush_size: "د برش اندازه تنظیم کړئ",
    tool_bucket: "ډک کړئ (Ctrl+F)",
    tool_eyedropper: "د سترګو څاڅکی",
    tool_grid: "گرډ (Ctrl+Shift+B)",
    tool_rotate: "ګرځول (Ctrl+Shift+R)",
    tool_flip_h: "فلیپ H (Ctrl+Shift+H)",
    tool_flip_v: "فلیپ V (Ctrl+Shift+V)",
    tool_transpose: "انتقال (Ctrl+Shift+T)",
    label_width: "عرض",
    label_height: "لوړوالی",
    label_frames: "د چوکاټونو شمیر",
    label_animation: "د حرکت انداز",
    label_background_color: "د شاليد رنګ",
    label_interval: "وقفه",
    tool_anim_config: "د حرکت ترتیب",
    label_new_width: "نوی عرض",
    label_new_height: "نوی لوړوالی",
    label_apply: "درخواست وکړئ",
    label_colors: "رنګونه",
    label_size: "اندازه",
    label_tolerance: "زغم",
    val_horizontal: "افقی",
    val_vertical: "عمودی",
    val_sequence: "ترتیب",
    val_bounce: "اچول",
    val_random: "تصادفي",
    val_solid: "سالم",
    val_clear: "روښانه",
    action_add_sheet: "نوې پاڼه",
    action_import: "واردول",
    action_export: "صادرول",
    action_sort_projects: "ترتیب",
    sort_date_old: "زوړ لومړی",
    sort_date_new: "تر ټولو تازه لومړی",
    sort_name_az: "نوم (A-Z)",
    sort_name_za: "نوم (Z-A)",
    action_new_sprite: "نوی سپریټ",
    action_new_project: "نوې پروژه",
    modal_save_all_title: "ټول بدلونونه خوندي کړئ",
    modal_save_all_desc: "د خوندي کولو لپاره شتمنۍ غوره کړئ:",
    modal_save_selected: "انتخاب شوی خوندي کړئ",
    action_saved: "خوندي شوی",
    modal_create_sprite_title: "نوی سپریټ جوړ کړئ",
    modal_create_project_title: "نوې پروژه جوړه کړئ",
    modal_add_sheet_title: "نوې پاڼه اضافه کړئ",
    modal_rename_sheet_title: "د شیټ نوم بدل کړئ",
    modal_rename_sprite_title: "د سپرایټ نوم بدل کړئ",
    modal_delete_sprite_title: "سپرایټ ړنګ کړئ",
    modal_delete_project_title: "پروژه ړنګه کړئ",
    modal_delete_sheet_title: "پاڼه ړنګ کړئ",
    placeholder_sprite_name: "نوم",
    placeholder_project_name: "نوم",
    placeholder_sheet_name: "نوم",
    placeholder_new_name: "نوی نوم",
    action_create: "جوړ کړئ",
    action_add: "اضافه کړئ",
    action_rename: "نوم بدل کړئ",
    action_duplicate: "نقل",
    action_delete: "ړنګول",
    action_cancel: "لغوه کړئ",
    confirm_delete_sprite: "ایا تاسو ډاډه یاست چې تاسو غواړئ دا سپریټ ړنګ کړئ؟",
    confirm_delete_project: "ایا تاسو ډاډه یاست چې تاسو دا پروژه حذف کول غواړئ؟ ټول سپریټونه به لیرې شي.",
    confirm_delete_sheet: "ایا تاسو ډاډه یاست چې دا پاڼه حذف کول غواړئ؟",
    err_select_sprite: "مهرباني وکړئ لومړی یو سپریټ غوره کړئ.",
    err_select_project: "مهرباني وکړئ لومړی یوه پروژه غوره کړئ.",
    err_name_empty: "نوم خالي نه وي.",
    err_sprite_exists: "د دې نوم سره یو سپریټ لا دمخه شتون لري.",
    err_project_exists: "د دې نوم سره یوه پروژه لا دمخه شتون لري.",
    err_no_content: "د خوندي کولو لپاره هیڅ مینځپانګه نشته.",
    err_no_changes: "د خوندي کولو لپاره هیڅ بدلون نشته.",
    err_delete_last_sheet: "وروستۍ پاڼه ړنګولای نشي.",
    err_extract_frames: "هیڅ چوکاټ نشي ایستل کیدی.",
    err_indexeddb: "په محلي توګه په خوندي کولو کې پاتې راغلل. ستاسو براوزر ممکن د IndexedDB ملاتړ ونه کړي.",
    msg_upload_success: "اپلوډ بریالی شو: {0}",
    msg_upload_failed: "اپلوډ ناکام شو: {0}",
    msg_save_success: "بریالي خوندي کړئ.",
    msg_saving: "خوندي کول...",
    msg_multi_save_result: "خوندي شوي {0} شتمنۍ. {1} ناکامۍ",
    menu_title: "مینو",
    menu_save: "خوندي کړئ",
    menu_save_all: "ټول خوندي کړئ",
    menu_support: "د ملاتړ سره اړیکه ونیسئ",
    label_local_storage: "ځایی ذخیره",
    label_sign_in: "ننوتل",
    modal_export_title: "سپرایټ صادر کړئ",
    label_filename: "د دوتنې نوم",
    label_format: "بڼه",
    action_export_confirm: "صادرول",
};

export default translations;
